import { render } from "./ServiceDetailView.vue?vue&type=template&id=3c8746a2"
import script from "./ServiceDetailView.vue?vue&type=script&lang=js"
export * from "./ServiceDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__